import { render } from "./HeroImage.vue?vue&type=template&id=38851935&scoped=true"
const script = {}

import "./HeroImage.vue?vue&type=style&index=0&id=38851935&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38851935"]])

export default __exports__